import { useQuery } from "@tanstack/react-query";
import { DesignPackageServices } from "@/services/bedrock/DesignPackageServices";
import { designKeys } from "@/services/bedrock/queryKeys";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

/**
 * Every published design the player can use, most recently published first. A player's own come from
 * the session server-side; a coach names the player. A null id keeps the query off.
 */
export function useAvailableDesigns(playerId: number | null | undefined) {
  const { isPlayer } = useSocialCoachSession();
  return useQuery({
    queryKey: designKeys.availableDesigns(playerId ?? -1),
    queryFn: () =>
      DesignPackageServices.list({
        scope: "available",
        ...(isPlayer ? {} : { playerId: playerId ?? undefined }),
        perPage: 50,
      }),
    enabled: playerId != null,
    staleTime: 60_000,
    select: page => page.content,
  });
}
